<template>
  <footer class="footer ziperase-footer">
    <div class="container-fluid d-flex p-4">
      <div class="box">
        <p
          v-if="showPrivacyNotice"
          class="license-link mb-0 mr-4"
          @click="showPrivacyNoticeModal"
        >
          Privacy Notice
        </p>
        <p v-if="showEula" class="license-link mb-0" @click="showEulaModal">
          License Agreement
        </p>
      </div>
      <div class="box center-box">
        &copy; 2025 Ziperase. All rights reserved.
      </div>
      <div class="box"></div>
    </div>
    <privacy-notice-modal></privacy-notice-modal>
    <eula-modal></eula-modal>
  </footer>
</template>
<script>
import EulaModal from "../../components/Modals/EulaModal.vue";
import PrivacyNoticeModal from "../../components/Modals/PrivacyNoticeModal.vue";
import config from "../../constants/config";

export default {
  components: {
    EulaModal,
    PrivacyNoticeModal
  },
  props: {
    showEula: {
      default: true
    },
    showPrivacyNotice: {
      default: true
    }
  },
  methods: {
    showEulaModal() {
      this.$bvModal.show(config.EULA_MODAL_ID);
    },
    showPrivacyNoticeModal() {
      this.$bvModal.show(config.PRIVACY_NOTICE_MODAL_ID);
    }
  }
};
</script>

<style lang="scss" scoped>
.license-link {
  cursor: pointer;
}

.box {
  flex: 1;
  display: flex;
}

.box:first-child > span {
  margin-right: auto;
}
.center-box {
  justify-content: center;
}
.box:last-child > span {
  margin-left: auto;
}
</style>
